import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { IconButton, Tooltip } from "@mui/material";
import {
  AdminPanelSettingsRounded,
  BookmarkRounded,
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AddEditFollowUp from "./AddEditFollowUp";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { DropLi } from "../../hooks";
import { useTranslation } from "react-i18next";

const Inquiries = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Gender } = DropLi();
  const { branch, setLoader } = useContext(AppContext);
  const [inqs, setInqs] = useState([]);
  const [followUp, setFollowUp] = useState(false);
  const [inqData, setInqData] = useState();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Inquiry + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setInqs([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const handleAddEdit = (id) => {
    navigate(`/inquiry_form/${id || ""}`);
  };
  const handleView = (id) => {
    navigate(`/view_inquiry/${id}`);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("CfmTitle"),
      subTitle: t("inqDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Successfully"),
              subTitle: res.msg,
            });
            setInqs((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("Warning"),
              subTitle: res.msg,
            });
          }
        };
        API(endpoints.Inquiry).Delete(id, onComplete);
      },
    });
  };

  const handleFollowup = (data) => {
    setInqData(data);
    setFollowUp(true);
  };

  const handleMakeMember = (data) => {
    navigate(`/member_form/conv_inq_to_member/${data.id}`);
  };

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("View")}>
        <IconButton
          onClick={() => handleView(props.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      {!props.isMakeMember && (
        <Tooltip title={t("MakeMember")}>
          <IconButton
            onClick={() => handleMakeMember(props)}
            size="small"
            color="primary"
            className="mr-5 p-5"
          >
            <AdminPanelSettingsRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(props.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("FollowUp")}>
        <IconButton
          onClick={() => handleFollowup(props)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <BookmarkRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddInquiry")}</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: t("Name") },
          { id: "phone", label: t("Phone") },
          { id: "genderName", label: t("Gender") },
          { id: "city", label: t("City") },
          { id: "remark", label: t("Remark") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={inqs.map((j) => {
          var _gender = Gender.find((x) => x.id === j.gender);
          return {
            ...j,
            name: (
              <span className="link" onClick={() => handleView(j.id)}>
                {j.firstName + " " + j.lastName}
              </span>
            ),
            genderName: _gender && _gender.label,
            city: j.city && j.city.name,
          };
        })}
      />

      {/* Add Follow Up */}
      {followUp && (
        <Dialog show={followUp} onClose={false} maxWidth="sm">
          <AddEditFollowUp
            {...{ setShowForm: setFollowUp, setAlert, inqData }}
          />
        </Dialog>
      )}
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Inquiries;
